// extracted by mini-css-extract-plugin
export default {"outer__col":"treatment-advances_outer__col__f2wSQ"};